export const asignacionMasivaAreaNegocioNormalize = (x) => ({
    idAsignacionMasivaAreaNegocio: x.idAsignacionMasivaAreaNegocio ?? x.IdAsignacionMasivaAreaNegocio,
    idCurso: x.idCurso ?? x.IdCurso,
    idAreaNegocio: x.idAreaNegocio ?? x.IdAreaNegocio,
    fechaLimite: x.fechaLimite ?? x.FechaLimite,
    activo: x.activo ?? x.Activo ?? true,
});
